import { useState } from "react";
import { toast } from "sonner";
import { ADMIN_USERS, ROLES, ACTIVITY_LOG } from "../../data/adminData";
import { PageTitle, Table, Badge, Btn, dt, Card } from "./ui";

export default function Users() {
  const [users, setUsers] = useState(ADMIN_USERS);
  const toggle = (id) => {
    setUsers((p) => p.map((u) => (u.id === id ? { ...u, active: !u.active } : u)));
    toast.success("Lietotāja statuss mainīts (DEMO)");
  };
  return (
    <div data-testid="admin-users">
      <PageTitle right={<Btn variant="red" onClick={() => toast.info("Jauns lietotājs (DEMO)", { description: `Pieejamās lomas: ${ROLES.join(", ")}` })} data-testid="user-add">+ Pievienot lietotāju</Btn>}>
        Lietotāji un lomas ({users.length})
      </PageTitle>
      <Table head={["Lietotājs", "E-pasts", "Loma", "Pēdējā pieslēgšanās", "Statuss", ""]}>
        {users.map((u) => (
          <tr key={u.id} className="border-b border-[#F5F5F5] hover:bg-[#F5F5F5]" data-testid={`user-row-${u.id}`}>
            <td className="p-3 font-bold">{u.name}</td>
            <td className="text-[#6B6B6B]">{u.email}</td>
            <td><Badge color={u.role === "Superadministrators" ? "red" : "black"}>{u.role}</Badge></td>
            <td className="text-[#6B6B6B]">{dt(u.lastLogin)}</td>
            <td><Badge color={u.active ? "green" : "gray"}>{u.active ? "Aktīvs" : "Deaktivizēts"}</Badge></td>
            <td className="p-3"><Btn variant="outline" onClick={() => toggle(u.id)} data-testid={`user-toggle-${u.id}`}>{u.active ? "Deaktivizēt" : "Aktivizēt"}</Btn></td>
          </tr>
        ))}
      </Table>
      <Card className="p-5 mt-6" data-testid="activity-log">
        <h2 className="text-sm font-bold uppercase tracking-widest mb-4">Aktivitāšu žurnāls</h2>
        <div className="space-y-2">
          {ACTIVITY_LOG.map((a) => (
            <div key={a.id} className="flex flex-wrap gap-x-3 text-sm border-b border-[#F5F5F5] pb-2">
              <span className="text-[#6B6B6B] w-20 shrink-0">{dt(a.date)}</span>
              <span className="font-semibold text-[#D0121A]">{a.user.split("@")[0]}</span>
              <span className="flex-1">{a.action}</span>
            </div>
          ))}
        </div>
      </Card>
    </div>
  );
}
